export default /*START_META*/{
  "title": "Signing up for Karix and Using as SMS gateway"
}; /*END_META*/